export default {
  brand: 'Corendon',
  brandTagline: 'Service Reception',
  heroTitle: 'Welkom bij Corendon Service Reception',
  heroSubtitle: 'Spreek met onze digitale assistent over uw vlucht, omboeking of bevestiging.',
  startButton: 'Start gesprek',
  endButton: 'Beëindig gesprek',
  loading: 'Verbinden…',
  micHint: 'U geeft de browser eenmalig toestemming voor de microfoon.',
  micPermissionTitle: 'Microfoontoegang nodig',
  micPermissionBody: 'Geef de browser toestemming voor de microfoon om met de assistent te spreken.',
  helpListTitle: 'Wij helpen u met:',
  helpItem1: 'Vluchtstatus en vertragingen',
  helpItem2: 'Boekingen wijzigen of omboeken',
  helpItem3: 'Bevestigingen per e-mail',
  pausedTitle: 'Gesprek gepauzeerd',
  pausedBody: 'Mobiele browsers kunnen audio niet op de achtergrond blijven afspelen. Open dit tabblad opnieuw om verder te gaan.',
  resumed: 'Welkom terug — we gaan verder waar we waren gebleven.',
  installPwaIos: 'Voor de beste ervaring: tik op het deel-icoon en kies "Zet op beginscherm".',
  installPwaAndroid: 'Installeer Corendon als app voor de beste ervaring.',
  installPwaButton: 'Installeren',
  installPwaDismiss: 'Niet nu',
  footerDemo: 'Demo-omgeving — deze service gebruikt fictieve boekingsgegevens.',
  errorGeneric: 'Er ging iets mis. Probeer het opnieuw.',
  errorAuthRequired: 'U moet inloggen om de assistent te gebruiken.',
  loginButton: 'Inloggen met Google',
}
